export default "__VITE_ASSET__Dfc$Ua20__";